import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for usage events corrections
 */
export class UsageEventCorrectionsService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.UsageEventCorrectionService.UsageEventCorrectionResponse | InterACT.Interfaces.UsageEventCorrectionService.UsageEventCorrectionsResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/usage-event-corrections/:usageEventCorrectionId');
  }

  /**
   * A method that saves the supplied usage event correction
   * @param usageEventCorrection the usage Event Correction to be saved
   */
  public save(usageEventCorrection: InterACT.Interfaces.UsageEventCorrectionService.UsageEventCorrection) {
    return this.resource.save(usageEventCorrection).$promise;
  }

  /**
   * Retrieves a single usage event corrections using the supplied id
   * @param id the id of the usage event corrections to retrieve
   * @return a promise that resolves with the usage event corrections when the operation is complete
   */
  public get(id: string) {
    return <ng.IPromise<InterACT.Interfaces.UsageEventCorrectionService.UsageEventCorrectionResponse>>this.resource.get({ usageEventCorrectionId: id }).$promise;
  }

  /**
   * A method that returns a number of usage events corrections for a given page and query
   * @param page the page number to retrieve
   * @param perPage the maximum number of usage events corrections to retrieve
   * @param query the query to use to filter the usage events corrections
   */
  public getList(page: number, perPage: number, query: string) {
    const requestOptions = this.resourceHelperService.buildRequestOptions(page, perPage, query);

    return <ng.IPromise<InterACT.Interfaces.UsageEventCorrectionService.UsageEventCorrectionsResponse>>this.resource.get(requestOptions).$promise;
  }
}
